import React from 'react';
import gpt3Logo from '../../logo.svg';
import './footer.css';

const Footer = () => (
  <div className="gpt3__footer section__padding">
    <div className="gpt3__footer-heading">
      <h1 className="gradient__text">We know you enjoyed using this tool</h1>
    </div>

    <div className="gpt3__footer-btn">
      <a><p>Spread The Word 😊</p></a>
      </div>      
      <div className="gpt3__footer-links_div">
        <h4>Do not be a stranger, get in touch</h4>
            <p>🚀🚀🚀olawandeoki@gmail.com</p>
      </div>
    
    <div className="gpt3__footer-copyright">
      <p>@2022 Boon Inc. All rights reserved.</p>
    </div>
    </div>
);

export default Footer;
